import { FieldWrapper, Input } from "../../../shared/ui";

const LABELS = {
  planned: { work: "Nettoarbeitszeit", travel: "Anfahrt", departure: "Abfahrt" },
  actual: { work: "Ist Stunden", travel: "Ist Anfahrt", departure: "Ist Abfahrt" },
};

type Props = {
  variant: "planned" | "actual";
  work: number;
  travel: number;
  departure: number | null;
};

export const TaskDurationPills = ({ variant, work, travel, departure }: Props) => {
  const labels = LABELS[variant];
  return (
    <div className="flex gap-3">
      <FieldWrapper label={labels.work} className="flex-1">
        <Input value={work} disabled />
      </FieldWrapper>
      <FieldWrapper label={labels.travel} className="flex-1">
        <Input value={travel} disabled />
      </FieldWrapper>
      <FieldWrapper label={labels.departure} className="flex-1">
        <Input value={departure ?? "—"} disabled />
      </FieldWrapper>
    </div>
  );
};
